import { useEffect, useState } from "react";
import { promiseText, type CoachingConfig } from "@coaching/config";
import type { Weekday } from "@coaching/types";
import { dueAfterWorkingDays, turnaroundText, workingDaysText, zonedDayClock } from "@coaching/workingDays";
import { loadCoachingConfig } from "../api";

const LONDON = zonedDayClock("Europe/London");

/** The promise as the players read it, from this coach's own settings, so the coach sees the same words. */
export function PromiseNote({ turnaroundDays, workingDays, cfg }: { turnaroundDays: number; workingDays: Weekday[]; cfg: CoachingConfig | null }) {
    const due = dueAfterWorkingDays(Date.now(), turnaroundDays, workingDays, LONDON);
    const dueText = new Date(due).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
    return (
        <div className="promise">
            <p className="promise-line">Players see: <strong>Back within {turnaroundText(turnaroundDays, workingDays)}</strong> ({workingDaysText(workingDays)}).</p>
            <p className="muted small">A request sent now would be due by the end of {dueText}. {cfg ? `Accept or decline within ${promiseText(cfg.acceptWithinHours)} of your next working day; the due date counts from when the player sent it.` : ""}</p>
        </div>
    );
}

/** The live coaching config, for the promise note and the turnaround ceiling. */
export function useCoachingConfig(): CoachingConfig | null {
    const [cfg, setCfg] = useState<CoachingConfig | null>(null);
    useEffect(() => {
        let alive = true;
        loadCoachingConfig().then((c) => { if (alive) setCfg(c); }).catch(() => { if (alive) setCfg(null); });
        return () => { alive = false; };
    }, []);
    return cfg;
}
